export default __webpack_public_path__ + "static/media/inspi2.2777b39a.jpg";